import { NO_OWNED_KINDS, ownedKindsOf, type OwnedKinds } from "@/shared/organizations/owned-kinds";
import { useUserMemberships } from "@/shared/organizations/use-user-memberships";

interface OwnedKindsUser {
  readonly id: string;
  readonly ownedVenues: readonly unknown[];
  readonly ownedProperties: readonly unknown[];
}

/**
 * What kinds of organization the user owns, from memberships (when the viewer
 * has `org.members.read`) and the user detail's owned venues / properties.
 * This is what founding and payouts gate on, never the legacy role label. The
 * memberships read shares its cache entry with the memberships section.
 */
export function useOwnedKinds(
  user: OwnedKindsUser | undefined,
  canReadMemberships: boolean,
): OwnedKinds {
  const memberships = useUserMemberships(user?.id, canReadMemberships);
  if (!user) return NO_OWNED_KINDS;
  return ownedKindsOf({
    memberships: memberships.data?.memberships ?? [],
    ownedVenues: user.ownedVenues,
    ownedProperties: user.ownedProperties,
  });
}
